// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** France */
const FR = /^(?:(?:6(?:[0-24-8]\d|3[0-8]|9[589])|7[3-9]\d)\d{6})$/;

export default FR;
